import { render, staticRenderFns } from "./scrollTab.vue?vue&type=template&id=dd483040&scoped=true&"
import script from "./scrollTab.vue?vue&type=script&lang=js&"
export * from "./scrollTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd483040",
  null
  
)

export default component.exports